<template>
  <div class="customer-stat-wrapper">
    <!-- 顶部：子标签 + 时间筛选 -->
    <div class="customer-stat">
      <div class="customer-stat-tabs">
        <div
          v-for="tab in customerStatTabs"
          :key="tab.key"
          class="customer-stat-tab"
          :class="{ active: customerStatActive === tab.key }"
          @click="customerStatActive = tab.key"
        >
          {{ tab.label }}
        </div>
      </div>
      <div class="customer-stat-actions">
        <a-radio-group size="small" :value="customerStatRange">
          <a-radio-button value="日">日</a-radio-button>
          <a-radio-button value="周">周</a-radio-button>
          <a-radio-button value="月">月</a-radio-button>
          <a-radio-button value="年">年</a-radio-button>
        </a-radio-group>
        <a-button size="small" icon="filter" />
        <a-select size="small" :value="customerStatMonth" class="filter-select">
          <a-select-option value="2024-08">2024-08</a-select-option>
        </a-select>
      </div>
    </div>

    <!-- 新增客户统计 -->
    <div class="customer-section">
      <div class="customer-section-title">
        新增客户统计
        <a-icon type="question-circle" class="section-help" />
      </div>
      <div class="customer-summary">
        <div class="summary-item-card">
          <div class="summary-label">目标新增(组)</div>
          <div class="summary-value">{{ customerNewSummary.target }}</div>
        </div>
        <div class="summary-item-card">
          <div class="summary-label">实际新增(组)</div>
          <div class="summary-value">{{ customerNewSummary.actual }}</div>
        </div>
        <div class="summary-item-card">
          <div class="summary-label">较7月</div>
          <div class="summary-value" :class="customerNewSummary.changeDirection">
            {{ customerNewSummary.change }}
          </div>
        </div>
      </div>
      <div class="customer-card-grid">
        <div class="customer-card" v-for="item in customerNewChannels" :key="item.label">
          <div class="card-title">{{ item.label }}</div>
          <div class="card-row">
            <span class="card-label">目标</span>
            <span class="card-value">{{ item.target }}</span>
          </div>
          <div class="card-row">
            <span class="card-label">实际</span>
            <span class="card-value highlight">{{ item.actual }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 到访客户统计 -->
    <div class="customer-section">
      <div class="customer-section-title">
        到访客户统计
        <a-icon type="question-circle" class="section-help" />
      </div>
      <div class="customer-summary">
        <div class="summary-item-card">
          <div class="summary-label">目标到访(组)</div>
          <div class="summary-value">{{ customerVisitSummary.target }}</div>
        </div>
        <div class="summary-item-card">
          <div class="summary-label">实际到访(组)</div>
          <div class="summary-value">{{ customerVisitSummary.actual }}</div>
        </div>
        <div class="summary-item-card">
          <div class="summary-label">较7月</div>
          <div class="summary-value" :class="customerVisitSummary.changeDirection">
            {{ customerVisitSummary.change }}
          </div>
        </div>
      </div>
      <div class="customer-card-grid">
        <div class="customer-card" v-for="item in customerVisitChannels" :key="item.label">
          <div class="card-title">{{ item.label }}</div>
          <div class="card-row">
            <span class="card-label">目标</span>
            <span class="card-value">{{ item.target }}</span>
          </div>
          <div class="card-row">
            <span class="card-label">实际</span>
            <span class="card-value highlight">{{ item.actual }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerStatTab',

  data() {
    return {
      customerStatActive: 'new',
      customerStatRange: '月',
      customerStatMonth: '2024-08',
      customerStatTabs: [
        { key: 'new', label: '新增客户' },
        { key: 'visit', label: '到访客户' },
        { key: 'return', label: '回访客户' }
      ],
      customerNewSummary: {
        target: '100',
        actual: '100',
        change: '15%',
        changeDirection: 'down'
      },
      customerVisitSummary: {
        target: '100',
        actual: '80',
        change: '20%',
        changeDirection: 'up'
      },
      customerNewChannels: [
        { label: '自然来访', target: '60', actual: '60' },
        { label: '个人拓客', target: '100', actual: '60' },
        { label: '小程序拓客', target: '60', actual: '60' },
        { label: '渠道拓客', target: '60', actual: '60' },
        { label: '来电', target: '100', actual: '60' }
      ],
      customerVisitChannels: [
        { label: '自然来访', target: '60', actual: '60' },
        { label: '转访', target: '100', actual: '60' },
        { label: '复访', target: '100', actual: '60' }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.customer-stat {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.customer-stat-tabs {
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: #5b6b7c;
}

.customer-stat-tab {
  padding: 4px 0;
  cursor: pointer;
  position: relative;
}

.customer-stat-tab.active {
  color: #1f2f3d;
  font-weight: 600;
}

.customer-stat-tab.active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -6px;
  height: 3px;
  border-radius: 2px;
  background: #2b6de5;
}

.customer-stat-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.customer-section {
  background: #ffffff;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 12px;
  border: 1px solid #f0f0f0;
}

.customer-section-title {
  font-weight: 600;
  color: #1f2f3d;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.section-help {
  color: #9aa5b1;
  font-size: 12px;
}

.customer-summary {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-bottom: 10px;
}

.summary-item-card {
  background: #f7f9fc;
  padding: 10px;
  border-radius: 8px;
}

.summary-label {
  font-size: 12px;
  color: #7a8699;
}

.summary-value {
  font-size: 16px;
  font-weight: 600;
  color: #1f2f3d;
  margin-top: 6px;
}

.summary-value.up {
  color: #2bb55d;
}

.summary-value.down {
  color: #ff6b6b;
}

.customer-card-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
}

.customer-card {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 10px;
  background: #ffffff;
}

.card-title {
  font-weight: 600;
  color: #1f2f3d;
  margin-bottom: 8px;
}

.card-row {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #5b6b7c;
}

.card-value.highlight {
  color: #2b6de5;
  font-weight: 600;
}
</style>
